import gettext from '@eb/gettext';
import { lazyGettext } from '@eb/lazy-gettext';

export const STATE_RESOURCE_CACHE_NAME = 'resourceCache';
export const EVENT_ID_REQUIRED_ERROR = lazyGettext(
    'Event Id is required to save publish settings.',
);
export const SCHEDULE_PRIVACY_PENDING = 'pending';

export const LISTED_PUBLIC = 'public';
export const LISTED_PRIVATE = 'private';
export const EVENT_PRIVACY_ACCESS_LINK = 'anyoneLink';
export const EVENT_PRIVACY_ACCESS_INVITE = 'inviteOnly';
export const EVENT_PRIVACY_ACCESS_PASSWORD = 'passwordProtected';
export const FORM_NAME = 'privacySettings';

// Storage key
export const PRIVACY_SETTINGS_STORAGE_KEY = 'privacySettingsStorage';
export const SCHEDULE_SETTINGS_STORAGE_KEY = 'scheduleSettingsStorage';
export const PUBLISH_OPTIONS_STORAGE_KEY = 'publishOptionsStorage';

export const PASSWORD_MAX_LENGTH = 50;
export const PASSWORD_LABEL = gettext('Password');

export const DEFAULT_PRIVACY_SETTINGS = {
    eventListing: LISTED_PUBLIC,
    eventPrivacyAccess: EVENT_PRIVACY_ACCESS_LINK,
    eventPassword: '',
};

export const PRIVACY_DESCRIPTION = lazyGettext(
    'Is your event open to the public, or is it a little more exclusive? Manage your privacy settings here.',
);
export const PUBLIC_EVENT_DESCRIPTION = lazyGettext(
    'Discoverable on Eventbrite, our distribution partners, and search engines.',
);
export const PRIVATE_EVENT_DESCRIPTION = lazyGettext(
    'Who can view this event?',
);

export const PRIVACY_VALUES_LABELS = {
    [LISTED_PUBLIC]: lazyGettext('Public'),
    [LISTED_PRIVATE]: lazyGettext('Private'),
};

export const PRIVACY_VALUES = [
    {
        value: LISTED_PUBLIC,
        display: PRIVACY_VALUES_LABELS[LISTED_PUBLIC],
        secondaryText: gettext('Shared on Eventbrite and search engines'),
    },
    {
        value: LISTED_PRIVATE,
        display: PRIVACY_VALUES_LABELS[LISTED_PRIVATE],
        secondaryText: gettext('Only available to a selected audience'),
    },
];

export const ID_REQUIRED_ERROR = lazyGettext('Id is required.');

const EVENT_PRIVACY_ACCESS_LINK_VALUE = {
    value: EVENT_PRIVACY_ACCESS_LINK,
    display: lazyGettext('Anyone with the link'),
};

const EVENT_PRIVACY_ACCESS_INVITE_VALUE = {
    value: EVENT_PRIVACY_ACCESS_INVITE,
    display: lazyGettext('Only people with an Eventbrite invitation'),
};

const EVENT_PRIVACY_ACCESS_PASSWORD_VALUE = {
    value: EVENT_PRIVACY_ACCESS_PASSWORD,
    display: lazyGettext('Only people with the password'),
};

export const EVENT_PRIVACY_ACCESS_VALUES_LIST = [
    EVENT_PRIVACY_ACCESS_INVITE,
    EVENT_PRIVACY_ACCESS_LINK,
    EVENT_PRIVACY_ACCESS_PASSWORD,
];

export const EVENT_PRIVACY_ACCESS_VALUES = [
    EVENT_PRIVACY_ACCESS_LINK_VALUE,
    EVENT_PRIVACY_ACCESS_INVITE_VALUE,
    EVENT_PRIVACY_ACCESS_PASSWORD_VALUE,
];

export const LOCALIZED_TEXT = {
    privacy: lazyGettext('Privacy'),
    whoCanSee: lazyGettext('Who can see your event?'),
    chooseAudience: lazyGettext('Choose your audience'),
    audience: lazyGettext('Audience'),
};
